//import { Link } from "react-router-dom";

export default function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg fixed-top shadow-sm d-flex flex-wrap align-items-center justify-content-center justify-content-md-between mb-4">
        <div className="container">
            <a className="navbar-brand fw-bold d-flex col-auto text-decoration-none" href="/">
              <span className="logo"><img src="images/ProfitPalmAgency_logo.svg" alt="ProfitPalm Agency"/> </span>
            </a>
            <div className="nav col-auto">
              <div id="navbarMenu" className="collapse navbar-collapse">
                <ul className="navbar-nav ms-auto gap-lg-2">
                  <li className="nav-item"><a className="nav-link" href="#hero">Main</a></li>
                  <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
                  <li className="nav-item"><a className="nav-link" href="#about">About Us</a></li>
                  <li className="nav-item"><a className="nav-link" href="#contact">Contacts</a></li>
                </ul>
              </div>
            </div>
            <div className="col-auto text-end actions gap-2 d-flex">
             <a href="#consultation" className="btn btn-outline-primary">Free consultation</a>
             <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
                 <span className="navbar-toggler-icon"></span>
             </button>
            </div>
        </div>
    </nav>
  );
}
